enum ProjectEvents {

    // プロジェクト一覧取得
    GetAllProjectListStarted = "[ProjectEvents] GetAllProjectListStarted",
    GetAllProjectListComplete = "[ProjectEvents] GetAllProjectListComplete",
    // フィルター
    filterProjectListStart = "[ProjectEvents] filterProjectListStart",
    filterProjectListComplete = "[ProjectEvents] filterProjectListComplete",
    // プロジェクト更新
    UpdateProjectStarted = "[ProjectEvents] UpdateProjectStarted",
    UpdateProjectComplete = "[ProjectEvents] UpdateProjectComplete",
    UpdateProjectFailed = "[ProjectEvents] UpdateProjectFailed",
    // プロジェクトにビデオ（エビソード・関連）を追加
    AddVideoToProject = "[ProjectEvents] AddVideoToProject",
    AddVideoToProjectComplete = "[ProjectEvents] AddVideoToProjectComplete",
}
export default ProjectEvents;
